
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ExternalLink, Plus } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "react-i18next";
import { useIsMobile } from '@/hooks/use-mobile';

interface PlatformContentProps {
  description: string;
  features?: string[];
  connected?: boolean;
  onAction: () => void;
  isSupported?: boolean;
}

export const PlatformContent = ({ 
  description, 
  features = [], 
  connected = false,
  onAction,
  isSupported = false
}: PlatformContentProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  
  return (
    <>
      <p className="text-xs md:text-sm text-muted-foreground mb-4 line-clamp-3 md:line-clamp-none">{description}</p>
      {features.length > 0 && (
        <div className="mb-4">
          <div className="flex flex-wrap gap-2">
            {features.map(feature => (
              <Badge key={feature} variant="secondary" className="bg-accent text-xs">
                {feature}
              </Badge>
            ))}
          </div>
        </div>
      )}
      <div className="flex justify-end">
        {!isSupported ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button 
                  variant="outline" 
                  size={isMobile ? "sm" : "sm"}
                  disabled 
                  className="text-muted-foreground"
                >
                  <Plus size={16} className="mr-1" />
                  <span>{t('create_profile')}</span>
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{t('coming_soon_tooltip')}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          <Button 
            variant={connected ? "outline" : "default"} 
            size={isMobile ? "sm" : "sm"}
            onClick={onAction}
            data-tour="create-profile"
          >
            {connected ? (
              <>
                <span>{t('manage')}</span>
                <ExternalLink size={14} className="ml-1" />
              </>
            ) : (
              <>
                <Plus size={16} className="mr-1" />
                <span>{isMobile ? t('connect') : t('create_profile')}</span>
              </>
            )}
          </Button>
        )}
      </div>
    </>
  );
};
